import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IjournalCategory } from '@app/+journal-main/journal-main.interface';
import { UrlGeneratorService } from '@app/core/i18n';
import { RoutingService } from '@app/core/services/routing.service';
import { DEFAULT_CATEGORY } from '@app/+journal-main/journal-main.service';

@Component({
  selector: 'vc-journal-main-breadcrumb',
  templateUrl: './journal-main-breadcrumb.component.html',
  styleUrls: ['./journal-main-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JournalMainBreadcrumbComponent implements OnInit {
  @Input() currentCategory: IjournalCategory;
  currentPath: string;
  completeUrl: string;

  public defaultCategory = DEFAULT_CATEGORY;

  constructor(
    private route: ActivatedRoute,
    private routingService: RoutingService,
    private urlGenerator: UrlGeneratorService
  ) {}

  ngOnInit() {
    this.route.root.firstChild.url.subscribe(
      url => {
        this.currentPath = this.routingService.buildPath(url);
        this.completeUrl = this.urlGenerator.generateUrl(this.currentPath);
      },
      err => (this.currentPath = '')
    );
  }
}
